import React, { useEffect } from "react";
import { Link } from "@reach/router";
import moment from "moment";
import InstanceCard from "../components/InstanceCard";
import HL from "../components/HL";
import { useState } from "react";
import ErrorPopup from "../components/ErrorPopup";
import {
  updateInstanceByID,
  encode,
  createInstance,
  fetchInstanceByID,
} from "../utils/api";
import { Button, BackButton } from "../components/Buttons";
import {
  StyledNewInstance,
  RAGSContainer,
  ActionWrapper,
} from "../styles/StyledInstance";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Editor } from "react-draft-wysiwyg";
import "../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
function Instance({ location }) {
  const {
    instanceID,
    projectID,
    sdl,
    tdl,
    pdl,
    projectName,
    clientName,
    clubName,
  } = location.state;
  const encoded = encode(clubName);
  const [isLocked, setLocked] = useState(false);
  const club = window.localStorage.getItem("club");
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [highlights, setHighlights] = useState([]);
  const [learnings, setLearnings] = useState([]);
  const [peopleFirst, setPeopleFirst] = useState({ score: null, comments: [] });
  const [delivery, setDelivery] = useState({ score: null, comments: [] });
  const [startDate, setStartDate] = useState(new Date());
  const [error, setError] = useState(null);
  const [commercialManagement, setCommercialManagement] = useState({
    score: null,
    comments: [],
  });
  const [techQuality, setTechQuality] = useState({ score: null, comments: [] });
  const [clientManagement, setClientManagement] = useState({
    score: null,
    comments: [],
  });
  const [product, setProduct] = useState({ score: null, comments: [] });
  const [isSubmitted, setSubmitted] = useState(false);
  const isNewInstance = location.href.includes("new-instance");
  const indicators = [
    {
      name: "People",
      value: peopleFirst,
      setterFunction: setPeopleFirst,
    },
    { name: "Delivery", value: delivery, setterFunction: setDelivery },
    {
      name: "Commercial",
      value: commercialManagement,
      setterFunction: setCommercialManagement,
    },
    {
      name: "Technical",
      value: techQuality,
      setterFunction: setTechQuality,
    },
    {
      name: "Client",
      value: clientManagement,
      setterFunction: setClientManagement,
    },
    { name: "Product", value: product, setterFunction: setProduct },
  ];
  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
  };
  function getMonday(d) {
    d = new Date(d);
    var day = d.getDay(),
      diff = d.getDate() - day + (day === 0 ? -6 : 1);
    return new Date(d.setDate(diff));
  }
  useEffect(() => {
    if (!isNewInstance) {
      fetchInstanceByID(encoded, projectID, instanceID).then((res) => {
        const { instance, actions } = res;
        const {
          startDate,
          locked,
          product,
          clientManagement,
          delivery,
          highlights,
          learnings,
          peopleFirst,
          commercialManagement,
          techQuality,
        } = instance;
        if (locked) {
          setSubmitted(true);
          setLocked(true);
        }
        setProduct(product);
        setStartDate(new Date(startDate));
        setClientManagement(clientManagement);
        setDelivery(delivery);
        setHighlights(highlights);
        setLearnings(learnings);
        setPeopleFirst(peopleFirst);
        setCommercialManagement(commercialManagement);
        setTechQuality(techQuality);
        const rawContent = convertFromRaw(JSON.parse(actions)); //convert from JSON to contentstate understood by DraftJS, for EditorState obj to use
        setEditorState(EditorState.createWithContent(rawContent)); //create EditorState based on JSON data from DB and set into component state
      });
    }
  }, [club, instanceID, isNewInstance, projectID, encoded]);

  const onSaveChanges = () => {
    const contentState = editorState.getCurrentContent();
    setSubmitted(true);
    const body = {
      highlights,
      learnings,
      peopleFirst,
      delivery,
      commercialManagement,
      techQuality,
      clientManagement,
      product,
      projectID,
      actions: JSON.stringify(convertToRaw(contentState)),
      startDate: getMonday(startDate),
    };
    if (isNewInstance) {
      createInstance(encoded, projectID, body)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          if (err) setError(err);
        });
    } else {
      updateInstanceByID(encoded, projectID, instanceID, body)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          if (err) setError(err);
        });
    }
  };
  getMonday(new Date());
  const date = moment(getMonday(new Date())).format("DD/MM/YY");
  return (
    <StyledNewInstance>
      {error && <ErrorPopup errors={error.response.data.errors} />}
      <h1>Week Commencing {date}</h1>
      <p className="team">
        Team: {sdl} - SDL, {tdl} - TDL, {pdl} - PDL
      </p>
      <label>Reporting Date</label>
      <DatePicker
        className="date-picker"
        selected={startDate}
        required={true}
        onChange={(date) => setStartDate(date)}
      />
      <HL
        isLocked={isLocked}
        setHL={setHighlights}
        hl={highlights}
        keyword="Highlights"
      />
      <HL
        isLocked={isLocked}
        setHL={setLearnings}
        hl={learnings}
        keyword="Learnings"
      />
      <RAGSContainer>
        {indicators.map((ind, i) => {
          return (
            <InstanceCard
              isNewInstance={isNewInstance}
              value={ind.value}
              key={i}
              indicator={ind.name}
              setter={ind.setterFunction}
              isLocked={isLocked}
            />
          );
        })}
      </RAGSContainer>
      <ActionWrapper>
        <h2>Actions </h2>
        <Editor
          editorState={editorState}
          readOnly={isLocked}
          toolbar={{
            inline: { inDropdown: true },
            list: { inDropdown: true },
            textAlign: { inDropdown: true },
            link: { inDropdown: true },
            history: { inDropdown: true },
          }}
          onEditorStateChange={onEditorStateChange}
        />
      </ActionWrapper>
      <Button
        disabled={isSubmitted}
        func={onSaveChanges}
        value={"Save Changes"}
      />
      {isSubmitted && !error && !isLocked && (
        <p style={{ color: "#2797fe" }}>
          {isNewInstance ? "New" : ""} Instance successfully{" "}
          {isNewInstance ? "created" : "updated"}
        </p>
      )}
      <Link
        state={{
          id: projectID,
          projectName: projectName,
          clubName: clubName,
          clientName: clientName,
        }}
        to={`/project/${projectID}`}
      >
        <BackButton />
      </Link>
    </StyledNewInstance>
  );
}

export default Instance;
